<svelte:options tag="w-banner"/>
<script>
    export let bannerId = '';
</script>

<div class="col-lg-12" style="padding-bottom: 20px;">
  <a href="https://www5.smartadserver.com/ac?jump=1&nwid=1279&siteid=404538&pgname=ganadores&fmtid={bannerId}&visit=m&tmstp=[timestamp]&out=nonrich" target="_blank">
  <img src="https://www5.smartadserver.com/ac?out=nonrich&nwid=1279&siteid=404538&pgname=ganadores&fmtid={bannerId}&visit=m&tmstp=[timestamp]" border="0" alt="" style="width:100%;" /></a>
</div>